import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {ChartData} from "../models/chart-data";
import {ChartGetDataModel, ChartSetDataModel} from "../models/amchart/chart-exchange";
import {ChartListProps} from "../models/amchart/chart-list-props";
import {AddChartModel} from "../models/amchart/add-chart-model";
import {ChartLineModel} from "../models/amchart/chart-line-model";
import {CodeNameChartTabs} from "../models/code-name-chart-tabs";
import {ChartDataGUID} from "../models/chart-data-GUID";
import {TabDataGUID} from "../models/tab-data-GUID";
import {TabsModeGUID} from "../models/tabs-mode-GUID";
import {ChartHelper} from "../models/chart-helper";
import {GUID} from "../../shared/models/GUID-interface";
import {ChartVisibilityGUID} from "../models/chart-visibility-GUID";
import {BGChartType} from "../models/b-g-chart-type";
import {
    ChartDimensionsGUID,
    GenerateLinesGUID,
    HoverLineGUID, LoadingSummaryLineDataGUID, RangeAggGUID, UpdateChartAggGUID, UpdateChartGUID,
    UpdateInfoParamGUID,
    UpdateStaticPopupGUID
} from "../models/update-static-popup-GUID";
import {b} from "@angular/core/src/render3";

@Injectable()
export class BufferGraphDataExchangeService{

    private newChartDataSource = new BehaviorSubject(null);
    newChartDataCurrent = this.newChartDataSource.asObservable();

    private showTargetLevelSource = new BehaviorSubject(null);
    showTargetLevelCurrent = this.showTargetLevelSource.asObservable();

    private updateChartDataSource = new BehaviorSubject(null);
    updateChartDataCurrent = this.updateChartDataSource.asObservable();

    private chartGetDataSource = new BehaviorSubject([]);
    chartGetDataCurrent = this.chartGetDataSource.asObservable();

    private chartListPropsSource = new BehaviorSubject([]);
    chartListPropsCurrent = this.chartListPropsSource.asObservable();

    private addCompareChartSource = new BehaviorSubject(null);
    addCompareChartCurrent = this.addCompareChartSource.asObservable();

    private toggleBubbleChartSource = new BehaviorSubject(null);
    toggleBubbleChartCurrent = this.toggleBubbleChartSource.asObservable();

    private toggleChartInfoSource = new BehaviorSubject(null);
    toggleChartInfoCurrent = this.toggleChartInfoSource.asObservable();

    private toggleLinesVisibilitySource = new BehaviorSubject(null);
    toggleLinesVisibilityCurrent = this.toggleLinesVisibilitySource.asObservable();

    private updateChartZoomSource = new BehaviorSubject(null);
    updateChartZoomCurrent = this.updateChartZoomSource.asObservable();

    private customChartPopperUpdateSource = new BehaviorSubject(null);
    customChartPopperUpdateCurrent = this.customChartPopperUpdateSource.asObservable();

    private compareChartReadySource = new BehaviorSubject(null);
    compareChartReadyCurrent = this.compareChartReadySource.asObservable();

    private tabsResizeSource = new BehaviorSubject(null);
    tabsResizeCurrent = this.tabsResizeSource.asObservable();

    private tabsListSource = new BehaviorSubject([]);
    tabsListCurrent = this.tabsListSource.asObservable();

    private tabsListGUIDSource = new BehaviorSubject('');
    tabsListGUIDCurrent = this.tabsListGUIDSource.asObservable();

    private chartDataSource = new BehaviorSubject([]);
    chartDataCurrent = this.chartDataSource.asObservable();

    private tabsDataSource = new BehaviorSubject([]);
    tabsDataCurrent = this.tabsDataSource.asObservable();

    private tabsModeSource = new BehaviorSubject([]);
    tabsModeCurrent = this.tabsModeSource.asObservable();

    private glassSource = new BehaviorSubject(null);
    glassCurrent = this.glassSource.asObservable();

    private hideGridDropdownsSource = new BehaviorSubject(null);
    hideGridDropdownsCurrent = this.hideGridDropdownsSource.asObservable();

    private chartVisibilitySource = new BehaviorSubject([]);
    chartVisibilityCurrent = this.chartVisibilitySource.asObservable();

    private chartCalcStaticPopupSource = new BehaviorSubject(null);
    chartCalcStaticPopupCurrent = this.chartCalcStaticPopupSource.asObservable();

    private chartUpdateInfoParamSource = new BehaviorSubject(null);
    chartUpdateInfoParamCurrent = this.chartUpdateInfoParamSource.asObservable();

    private chartGenerateInfoLinesSource = new BehaviorSubject(null);
    chartGenerateInfoLinesCurrent = this.chartGenerateInfoLinesSource.asObservable();

    private chartInfoLinesStorageSource = new BehaviorSubject([]);
    chartInfoLinesStorageCurrent = this.chartInfoLinesStorageSource.asObservable();

    private chartHoverLinesSource = new BehaviorSubject(null);
    chartHoverLinesCurrent = this.chartHoverLinesSource.asObservable();

    private chartLoadSummaryLineDataSource = new BehaviorSubject(null);
    chartLoadSummaryLineDataCurrent = this.chartLoadSummaryLineDataSource.asObservable();

    private chartUpdateAggregationsSource = new BehaviorSubject(null);
    chartUpdateAggregationsCurrent = this.chartUpdateAggregationsSource.asObservable();

    private chartObjUpdateSource = new BehaviorSubject(null);
    chartObjUpdateCurrent = this.chartObjUpdateSource.asObservable();

    private chartAggRangeSource = new BehaviorSubject([]);
    chartAggRangeCurrent = this.chartAggRangeSource.asObservable();

    private chartAggSource = new BehaviorSubject(null);
    chartAggCurrent = this.chartAggSource.asObservable();

    private updateChartDimensionsSource = new BehaviorSubject(null);
    updateChartDimensionsCurrent = this.updateChartDimensionsSource.asObservable();

    private helper: ChartHelper;


    constructor(){
        this.helper = new ChartHelper();
    }

    // setRegistryType = (registryType: number): void =>{
    //     this.registryTypeSource.next(registryType);
    // };
    //
    // getRegistryType = () =>{
    //     return this.registryTypeCurrent
    // };

    //# send a request for data for the chart
    setNewChartData = (data: ChartGetDataModel): void =>{
        this.newChartDataSource.next(data);
    };

    //# show target level on line chart
    setShowTargetLevel = (show: boolean): void =>{
        this.showTargetLevelSource.next(show);
    };

    //# send a request for update data for the chart and tabs
    setUpdateChartData = (chartData: ChartSetDataModel): void =>{
        this.updateChartDataSource.next(chartData);
        this.updateChartDataSource.next(null);
    };

    //# save chart getData in service (in period-selector component)
    setChartGetData = (chartGetData: ChartGetDataModel): void =>{
        let chartGetDataArr: ChartGetDataModel[] = this.getChartGetData();
            // chartGetDataCur = new ChartGetDataModel(this.GUID, this.sharedGUID, this.chartType, this.itemId, this.startDate, this.endDate);
        if (chartGetDataArr.length){
            chartGetDataArr.forEach((item, i, arr) =>{
                if (item.GUID === chartGetData.GUID){
                    arr[i] = chartGetData;
                }
            })
        } else{
            chartGetDataArr.push(chartGetData);
        }
        this.chartGetDataSource.next(chartGetDataArr);
    };

    //# get chart getData in service (in period-selector component)
    getChartGetData = (): ChartGetDataModel[] =>{
        return this.chartGetDataSource.getValue();
    };

    //# data bank for period-selector (set filter restrictions for sku and warehouse filter)
    setChartListProps = (chartGetData: ChartListProps[]): void =>{
        this.chartListPropsSource.next(chartGetData);
    };

    //# data bank for period-selector (set filter restrictions for sku and warehouse filter)
    getChartListProps = (): ChartListProps[] => {
        return this.chartListPropsSource.getValue();
    };

    //# send a request for add compare chart
    setAddChart = (chart: AddChartModel): void =>{
        this.addCompareChartSource.next(chart);
    };

    //# toggle bubble chart visibility
    setToggleBubbleChart = (data: {type: BGChartType, sharedGUID: string, show: boolean}): void =>{
        this.toggleBubbleChartSource.next(data);
    };

    //# toggle info in chart visibility
    setToggleChartInfo = (data: {type: BGChartType, sharedGUID: string, show: boolean}): void =>{
        this.toggleChartInfoSource.next(data);
    };

    //# sync line visibility on charts main and compare
    setToggleLinesVisibility = (data: { type: BGChartType, sharedGUID: string, lineName: string, chart: string }): void =>{
        this.toggleLinesVisibilitySource.next(data);
        this.toggleLinesVisibilitySource.next(null);
    };

    //# sync zoom on charts main and compare
    setUpdateChartZoom = (data: {type: BGChartType, sharedGUID: string, start: Date, end: Date, startFull: boolean, endFull: boolean}): void =>{
        this.updateChartZoomSource.next(data);
    };

    //# update add compare charts popper if chart dimension changes
    setCustomChartPopperUpdate = (val: boolean): void =>{
        this.customChartPopperUpdateSource.next(val);
    };

    //# notify when compare chart ready,
    setCompareChartReady = (data: {command: string, type: BGChartType, sharedGUID: string, lines: ChartLineModel[]}): void =>{
        this.compareChartReadySource.next(data);
        this.compareChartReadySource.next(null);
    };

    //# update tab dimensions, update grid inside tabs
    notifyTabsResize = (sharedGUID: string): void =>{
        this.tabsResizeSource.next(sharedGUID);
    };

    //# add or update tablist
    setTabsList = (tabList: CodeNameChartTabs): void =>{
        let allTabsData = this.tabsListSource.getValue(),
            set: boolean = false;
        allTabsData.forEach((item, i, arr) => {
            if (item.GUID === tabList.GUID){
                arr[i] = tabList;
                set = true;
            }
        });

        // console.trace(set, allTabsData, 'setTabsList')

        !set ? allTabsData.push(tabList) : null;
        // console.log(set, allTabsData, 'setTabsList');

        this.tabsListSource.next(allTabsData);
        this.tabsListGUIDSource.next(tabList.GUID);
        // this.tabsListGUIDSource.next('');
    };

    //# get needed tablist
    getTabsList = (GUID: string): CodeNameChartTabs =>{
        let allTabsData: CodeNameChartTabs[] = this.tabsListSource.getValue();
        return allTabsData ? allTabsData.find(item => item.GUID === GUID) : null;
        // return allTabsData ? allTabsData.filter(item => item.GUID === GUID).find(item => item) : null;
    };

    //# add or update chart visibility
    setChartVisibility = (visibility: ChartVisibilityGUID): void =>{
        let allVisibility: ChartVisibilityGUID[] = this.chartVisibilitySource.getValue(),
            set: boolean = false;
        allVisibility.forEach((item, i, arr) => {
            if (item.GUID === visibility.GUID){
                arr[i].hideChart = visibility.hideChart;
                set = true;
            }
        });

        !set ? allVisibility.push(visibility) : null;

        this.chartVisibilitySource.next(allVisibility);
    };

    //# get needed visibility for chart
    getChartVisibility = (GUID: string): ChartVisibilityGUID =>{
        let allVisibility: ChartVisibilityGUID[] = this.chartVisibilitySource.getValue();
        return allVisibility ? allVisibility.find(item => item.GUID === GUID) : null;
    };

    //# get needed tablist
    getTabsList2 = (): CodeNameChartTabs[] =>{
        return this.tabsListSource.getValue();

    };

    //# save chart data to service
    setChartData = (chartData: ChartDataGUID): void =>{
        let allChartData: ChartDataGUID[]  = this.chartDataSource.getValue(),
            set: boolean = false;
        allChartData.forEach((item, i, arr) => {
            if (item.GUID === chartData.GUID){
                arr[i] = chartData;
                set = true;
            }
        });

        !set ? allChartData.push(chartData) : null;
        this.chartDataSource.next(allChartData);
    };

    //# get chart data from service
    getChartData = (GUID: string, itemId: number): ChartDataGUID =>{
        let allChartData: ChartDataGUID[] = this.chartDataSource.getValue();
        return allChartData && allChartData.length ? allChartData.find(item => item.GUID === GUID && item.data.itemInfo.itemId === itemId) : null;
    };

    //# remove chart data from service
    delChartData = (GUID: string): void =>{
        // console.trace('delTabsData')
        let allChartData: TabsModeGUID[] = this.chartDataSource.getValue();
        this.helper.remFromArr(allChartData, 'GUID', GUID);
        this.chartDataSource.next(allChartData);
    };

    //# save tabs data to service
    setTabsData = (tabData: TabDataGUID): void =>{
            // console.log(tabData, (tabData.data as any).rows && (tabData.data as any).rows.length, (tabData.data as any).rows, 'setTabsData')

            let allTabsData: TabDataGUID[]  = this.tabsDataSource.getValue(),
                set: boolean = false;
            allTabsData.forEach((item, i, arr) => {
                if (item.GUID === tabData.GUID){
                    arr[i] = tabData;
                    set = true;
                }
            });

            !set ? allTabsData.push(tabData) : null;
            this.tabsDataSource.next(allTabsData);

    };

    //# get tabs data from service
    getTabsData = (GUID: string, itemId: number): TabDataGUID =>{
        let allTabsData: TabDataGUID[] = this.tabsDataSource.getValue();
        let tabData = allTabsData && allTabsData.length
            ? allTabsData.find(item => item.GUID === GUID && item.data.length && item.data[0].itemInfo.itemId === itemId)
            : null;

        // tabData && console.log(tabData.data, (tabData.data as any).rows && (tabData.data as any).rows.length, (tabData.data as any).rows, 'getTabsData');
        if (tabData && (tabData.data as any).rows && (tabData.data as any).rows.length){
            (tabData.data as any).rows = (tabData.data as any).rows.filter(r => {
                r.rowHeight = null;
                return !r.hideRow;
            })
        }
        return tabData;
    };

    //# remove tabs data from service
    delTabsData = (GUID: string): void =>{
        // console.trace('delTabsData')
        let allTabsData: TabsModeGUID[] = this.tabsDataSource.getValue();
        this.helper.remFromArr(allTabsData, 'GUID', GUID);
        this.tabsDataSource.next(allTabsData);
    };

    //# save tabs display settings to service
    setTabsMode = (tabsMode: TabsModeGUID): void =>{
        // console.log(tabsMode, 'setTabsMode')
        let allTabsMode: TabsModeGUID[]  = this.tabsModeSource.getValue(),
            set: boolean = false;
        allTabsMode.forEach((item, i, arr) => {
            if (item.GUID === tabsMode.GUID){
                arr[i] = tabsMode;
                set = true;
            }
        });

        !set ? allTabsMode.push(tabsMode) : null;
        this.tabsModeSource.next(allTabsMode);
    };

    //# get tabs display settings from service
    getTabsMode = (GUID: string): TabsModeGUID =>{
        let tabsMode: TabsModeGUID[] = this.tabsModeSource.getValue();
        return tabsMode && tabsMode.length ? tabsMode.find(item => item.GUID === GUID) : null;
    };

    //# remove tabs display settings from service
    delTabsMode = (GUID: string): void =>{
        let allTabsMode: TabsModeGUID[] = this.tabsModeSource.getValue();
        this.helper.remFromArr(allTabsMode, 'GUID', GUID);
        this.tabsModeSource.next(allTabsMode);
    };

    //# notify set glass to chart,
    setGlass = (data: {sharedGUID: string, showGlass: boolean}): void =>{
        this.glassSource.next(data);
    };

    //# notify set glass to chart,
    setHideDropdown = (data: GUID): void =>{
        this.hideGridDropdownsSource.next(data);
        this.hideGridDropdownsSource.next(null);
    };

    updateStaticPopup = (data: UpdateStaticPopupGUID): void =>{
        this.chartCalcStaticPopupSource.next(data);
        this.chartCalcStaticPopupSource.next(null);
    };

    updateInfoParam = (data: UpdateInfoParamGUID): void =>{
        this.chartUpdateInfoParamSource.next(data);
        this.chartUpdateInfoParamSource.next(null);
    };

    generateInfoLines = (data: GenerateLinesGUID): void =>{
        this.chartGenerateInfoLinesSource.next(data);
        this.chartGenerateInfoLinesSource.next(null);
    };

    //# save chart data to service
    setChartLinesData = (chartLines: GenerateLinesGUID): void =>{
        let allChartLines: GenerateLinesGUID[]  = this.chartInfoLinesStorageSource.getValue(),
            set: boolean = false;
        allChartLines.forEach((item, i, arr) => {
            if (item.GUID === chartLines.GUID){
                arr[i] = chartLines;
                set = true;
            }
        });

        !set ? allChartLines.push(chartLines) : null;
        this.chartInfoLinesStorageSource.next(allChartLines);
    };

    //# get chart data from service
    getChartLinesData = (GUID: string): GenerateLinesGUID =>{
        let allChartData: GenerateLinesGUID[] = this.chartInfoLinesStorageSource.getValue();
        // console.log(allChartData, 'setChartLinesData')
        return allChartData && allChartData.length ? allChartData.find(item => item.GUID === GUID) : null;
    };

    setHoverLine = (data: HoverLineGUID): void =>{
        this.chartHoverLinesSource.next(data);
        this.chartHoverLinesSource.next(null);
    };

    setLoadSummaryLineData = (data: LoadingSummaryLineDataGUID): void =>{
        this.chartLoadSummaryLineDataSource.next(data);
        this.chartLoadSummaryLineDataSource.next(null);
    };

    setChartAggregations = (data: UpdateChartAggGUID): void =>{
        this.chartUpdateAggregationsSource.next(data);
        this.chartUpdateAggregationsSource.next(null);
    };

    updateChartObj = (data: UpdateChartGUID): void =>{
        this.chartObjUpdateSource.next(data);
        this.chartObjUpdateSource.next(null);
    };

    //# save chart data to service
    setAggRange = (chartLines: RangeAggGUID): void =>{
        let allChartLines: RangeAggGUID[]  = this.chartAggRangeSource.getValue(),
            set: boolean = false;
        allChartLines.forEach((item, i, arr) => {
            if (item.GUID === chartLines.GUID){
                arr[i] = chartLines;
                set = true;
            }
        });

        !set ? allChartLines.push(chartLines) : null;
        this.chartAggRangeSource.next(allChartLines);
    };

    //# get chart data from service
    getAggRange = (GUID: string): RangeAggGUID =>{
        let allChartData: RangeAggGUID[] = this.chartAggRangeSource.getValue();
        // console.log(allChartData, 'setChartLinesData')
        return allChartData && allChartData.length ? allChartData.find(item => item.GUID === GUID) : new RangeAggGUID(GUID, null);
    };

    calcAgg = (data: RangeAggGUID): void =>{
        this.chartAggSource.next(data);
        this.chartAggSource.next(null);
    };

    updateChartDimensions = (data: string): void =>{
        this.updateChartDimensionsSource.next(data);
        this.updateChartDimensionsSource.next(null);
    };

}






// WEBPACK FOOTER //
// ./src/app/buffer-graph/services/buffer-graph-data-exchange.service.ts